import { Link } from "react-router-dom";
import Icon from "./Icon";
import { formatNumber } from "../utils/format";

const CommunityCard = ({ community, guild }) => (
  <article className="panel flex flex-col gap-4">
    <div className="flex items-center justify-between text-xs uppercase tracking-[0.3em] text-slate-500">
      <div className="flex items-center gap-2">
        <span className="icon-badge icon-badge--mint">
          <Icon name="shield" className="h-4 w-4" />
        </span>
        <span className="capitalize text-slate-100">{community.status}</span>
      </div>
      <span>{community.region}</span>
    </div>
    <div>
      <p className="text-xs uppercase tracking-[0.35em] text-slate-500">{guild?.name}</p>
      <h3 className="text-2xl text-slate-100">{community.name}</h3>
      <p className="mt-2 text-sm text-slate-300">{community.summary}</p>
    </div>
    <div className="flex flex-wrap gap-3 text-sm text-slate-400">
      <span>{community.city}</span>
      <span className="text-brand-steel">•</span>
      <span>{formatNumber(community.memberCount)} members</span>
      <span className="text-brand-steel">•</span>
      <span className="capitalize">{community.activity} cadence</span>
    </div>
    <div className="flex flex-wrap gap-2">
      {community.tags.slice(0, 5).map((tag) => (
        <span key={tag} className="chip">
          {tag}
        </span>
      ))}
    </div>
    <div className="flex flex-wrap gap-3 text-sm">
      <Link to={`/communities/${community.id}`} className="btn-secondary">
        Open Profile
      </Link>
      <Link to={`/guilds/${community.guildId}`} className="text-brand-primary underline-offset-4 hover:underline">
        View Guild
      </Link>
    </div>
  </article>
);

export default CommunityCard;
